import { Type } from 'class-transformer';

export class PersonalInfo {
    id: number;
    @Type(() => Date) insuranceReferenceDate: Date = null;
    birthDate: Date = null;
    postalCode: string = null;
    houseNumber: string = null;
    healthInsuranceNumber: string = null;
    travelInsuranceNumber: string = null;

    public constructor(init?: Partial<PersonalInfo>) {
        Object.assign(this, init);
    }
}